<template>
	<div class="relative border-t-4 font-proxima-nova leading-tight tracking-normal text-center shadow-md" :style="{ 'borderColor': packInfo.color }">
		<div class="px-2 pt-4 pb-2" :class="{ invisible: !showingOverview }">
			<p class="text-2xl">{{ packInfo.name }}</p>
			<p class="text-7xl font-light">{{ packInfo.channelCount }}</p>
			<p class="uppercase -mt-3">Channels</p>

			<div class="mt-4 flex justify-center space-x-2">
				<div v-for="image in packInfo.thumbnails" :key="image" class="h-10 w-10">
					<img :src="`https://get.dishformyrv.com/hubfs/ChannelBoxes/Channel/Thumbnail/${image}`">
				</div>
			</div>

			<div class="mt-4 flex justify-center items-center leading-none">
				<p class="text-6xl font-light relative">
					<span class="absolute top-0 left-0 -ml-4 mt-2 text-3xl align-top">$</span>
					<span class="align-top">{{ price.dollar }}</span>
				</p>
				<div class="flex flex-col items-start">
					<span class="text-3xl">{{ price.cents }}</span>
					<span class="text-base">/mo.</span>
				</div>
			</div>
		</div>
		<div class="absolute pb-10 z-0 inset-0" :class="{ invisible: showingOverview }">
			<Simplebar class="h-full w-full">
				<div class="relative flex justify-center flex-wrap">
					<div v-for="image in lineup" :key="image" class="mt-2 flex-grow flex-shrink-0 px-2 xl:px-3">
						<img class="mx-auto" :src="`https://get.dishformyrv.com/hubfs/ChannelBoxes/Channel/Logo/${image}.png`">
					</div>
					<div class="absolute h-full w-full flex items-end">
						<div class="w-full pt-40 pb-20 bg-gradient-to-t from-white">
							<a class="text-white py-2 px-4 rounded inline-flex items-center space-x-2 hover:underline" :style="{ backgroundColor: packInfo.color }" target="_blank" rel="noopener noreferrer" :href="packInfo.pdfLink">
								<span>Download Full Lineup</span>
								<svg class="h-5 w-5" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
									<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
									<polyline points="7 10 12 15 17 10" />
									<line x1="12" y1="15" x2="12" y2="3" />
								</svg>
							</a>
						</div>
					</div>
				</div>
			</Simplebar>
		</div>
		<div class="relative cursor-pointer text-center py-3 px-6 text-xl text-white hover:underline" :style="controlStyles" @click="showingOverview = !showingOverview">
			<p>{{ showingOverview ? 'View Channels' : 'Return to Overview' }}</p>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent, PropType, ref } from 'vue'

	import Simplebar from '@/components/Simplebar.vue'
	import { ChannelPackInfo, usePackLineup } from '@/composables/useChannelPackInfo'

	export default defineComponent({
		components: {
			Simplebar,
		},

		props: {
			packInfo: {
				type: Object as PropType<ChannelPackInfo>,
				required: true,
			},
		},

		setup(props) {
			return {
				lineup: usePackLineup(props.packInfo.name),

				price: {
					dollar: Math.floor(props.packInfo.priceInCents / 100),
					cents: props.packInfo.priceInCents % 100,
				},

				controlStyles: {
					backgroundColor: props.packInfo.color,
					borderTopLeftRadius: '50% 1rem',
					borderTopRightRadius: '50% 1rem',
				},

				showingOverview: ref(true),
			}
		},
	})
</script>
